/*******************
 Globals
 ****************/

// print price ($51.27 = 5127)
function price(amount) {
    let total = (parseFloat(amount) / 100).toFixed(2);
    return `$${total.replace(".00", "")}`;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        this.closest("label").parentElement.querySelector('.active').classList.remove('active');
        this.closest("label").classList.add('active');
        updateProduct();
    });
})

// update active variant
function updateProduct() {
    // find new variant based on the active id (default variant doesn't get rendered)
    if (document.querySelector('.productVariant.active')) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector('.productVariant.active').dataset.variant)
        })[0];
    }

    oneTimeDiscount = parseFloat(document.querySelector("#product").dataset.oneTimeDiscount)
    subscriptionDiscount = parseFloat(document.querySelector("#product").dataset.subscriptionDiscount)

    // calculate 3 key variables
    let comparePrice, oneTimePrice, subscriptionPrice;

    // calculate compare price
    comparePrice = activeVariant.compare_at_price > activeVariant.price ? activeVariant.compare_at_price : activeVariant.price;

    // calculate one-time price
    oneTimePrice = activeVariant.price * oneTimeDiscount;

    // check for subscription
    if (product.selling_plan_groups.length > 0) {

        // calculate subscription price
        if (subscriptionDiscount < 1) {
            subscriptionPrice = activeVariant.price * subscriptionDiscount;
        } else {
            subscriptionPrice = activeVariant.selling_plan_allocations[0].per_delivery_price;
        }

        // update the onetime and subscription labels (X% OFF)
        if (oneTimeDiscount < 1) {
            document.querySelector("#productSingle ~ .productPlanItemLabel").textContent = `One-Time Purchase (${Math.round((1 - oneTimeDiscount) * 100)}% OFF):`;
        } else {
            document.querySelector("#productSingle ~ .productPlanItemLabel").textContent = `One-Time Purchase`;
        }
        if (subscriptionDiscount < 1) {
            document.querySelector("#productSubscribe ~ .productPlanItemLabel").textContent = `Subscribe + Save (${Math.round((1 - subscriptionDiscount) * 100)}% OFF):`;
        } else {
            document.querySelector("#productSubscribe ~ .productPlanItemLabel").textContent = `Subscribe + Save (${product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value}% OFF):`;
        }

        // one-time pricing
        if (comparePrice > oneTimePrice) {
            document.querySelector(".productPlanItemPrice").innerHTML = `
                <s>${price(comparePrice)}</s>
                ${price(oneTimePrice)}
            `;
        } else {
            document.querySelector(".productPlanItemPrice").textContent = price(oneTimePrice);
        }

        // subscription pricing
        document.querySelector("#productSubscribe ~ .productPlanItemPrice").textContent = price(subscriptionPrice);
    }

    // update atc buttons based on one-time or subscription
    if (document.querySelector("#productSubscribe:checked")) {
        if (comparePrice > subscriptionPrice) {
            document.querySelector("#productATCPrice").innerHTML = `
            <s>${price(comparePrice * quantity)}</s>
            ${price(subscriptionPrice * quantity)}
        `;
        } else {
            document.querySelector("#productATCPrice").textContent = price(subscriptionPrice * quantity);
        }
    } else {
        if (comparePrice > oneTimePrice) {
            document.querySelector("#productATCPrice").innerHTML = `
            <s>${price(comparePrice * quantity)}</s>
            ${price(oneTimePrice * quantity)}
        `;
        } else {
            document.querySelector("#productATCPrice").textContent = price(oneTimePrice * quantity);
        }
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATCLabel").textContent = "Add To Crate";
    } else {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATCLabel").textContent = "Sold Out";
    }
}

/****************
 * Product Quantity
 */

let quantity = 1;

// minus
document.querySelector("#productQuantityMinus").addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productQuantityValue").textContent = quantity
    updateProduct();
});

// plus
document.querySelector("#productQuantityPlus").addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productQuantityValue").textContent = quantity
    updateProduct();
});

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add zloading animation
    this.classList.add("zloading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // check for subscription
    if (document.querySelector("#productSubscribe:checked")) {
        formData.items[0].selling_plan = parseInt(document.querySelector("#productPlanItemPlans").value)
    }

    // add product
    await addProduct(formData);

    // remove zloading animation
    this.classList.remove("zloading");
});